import React, { useContext, useEffect } from 'react';

import AuthContext from 'common/auth';
import { useLocation, useNavigate } from 'react-router';

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  // S9: the session cookie is httpOnly, so JS can't read it. Gate on the user
  // resolved from /api/me instead, and wait for the initial session probe
  // (authChecked) so a logged-in user isn't bounced to /login on refresh.
  const { user, authChecked, setRedirect } = useContext(AuthContext)!;
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setRedirect(location.pathname);
  }, []);

  useEffect(() => {
    if (authChecked && !user) {
      navigate('/login');
    }
  }, [authChecked, user]);

  if (!authChecked) {
    return null;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
